import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';

@Component({
  selector: 'ba-preset-modal',
  templateUrl: './preset-modal.component.html',
  styleUrls: ['./preset-modal.component.css']
})
export class PresetModalComponent implements OnInit, OnDestroy {

  @Input() public presetModal = false;
  @Input() public ifPresetVisible = true;
  @Input() public presetMode: any;
  @Input() public presetData: any;
  @Input() public presetName: any;
  @Input() public selectedDataForPreset: any;
  @Input() public presetId: any;
  @Input() public selectedCol: any;
  @Input() public disabled: any;
  @Input() public ifCheckPreset: any;
  @Input() public listBoxOptions: any;
  @Input() public listBoxSelectedValue: any;
  @Input() public colLabel: any;
  @Input() public checkFlag: any;
  @Input() public defaultLabel: string = '';
  @Output() presetNameChanges = new EventEmitter();
  @Output() locationChanges = new EventEmitter();
  @Output() save = new EventEmitter();
  @Output() update = new EventEmitter();
  @Output() presetModalDelete = new EventEmitter();
  @Output() presetModalCancel = new EventEmitter();
  @Output() multiSelectChange = new EventEmitter();
  @Output() columnSelection = new EventEmitter();
  @Output() clearPresetSelection = new EventEmitter();
  @Output() presetSelection = new EventEmitter();
  @Output() columnEdit = new EventEmitter<object>();
  @Output() onPresetHide = new EventEmitter();

  constructor() { }

  ngOnInit() { }

  ngOnDestroy() {
    this.presetModalCancel.unsubscribe();
  }

  presetNameChange(event: any) {
    this.presetNameChanges.emit(event);
  }

  presetColumnsChange(event: any) {
    this.locationChanges.emit(event);
  }

  cancelPreset() {
    this.presetModalCancel.emit();
  }

  savePreset(event: any) {
    this.save.emit(event);
  }

  updatePreset(event: any) {
    this.update.emit(event);
  }

  deletePreset(event: any) {
    this.presetModalDelete.emit(event);
  }

  onmultiSelectChange(event: any, selectedCol: any) {
    this.multiSelectChange.emit({event, selectedCol});
  }

  onMultiSelectHide(event: any, selectedCol: any){
    this.onPresetHide.emit({event, selectedCol});
  }

  onColumnSelection(presetAction: any) {
    this.columnSelection.emit(presetAction);
  }

  onColumnEdit(presetAction: any, rowData: any) {
    this.columnEdit.emit({presetAction, rowData});
  }

  onClearPreset(event: any) {
    this.clearPresetSelection.emit(event);
  }

  onSelectPreset(event: any) {
    this.presetSelection.emit(event);
  }

}
